"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dayjs_1 = __importDefault(require("dayjs"));
var customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
var utc_1 = __importDefault(require("dayjs/plugin/utc"));
var ScheduleAvailabilityTimeHelper = /** @class */ (function () {
    function ScheduleAvailabilityTimeHelper() {
        dayjs_1.default.extend(utc_1.default);
        dayjs_1.default.extend(customParseFormat_1.default);
    }
    ScheduleAvailabilityTimeHelper.prototype.isAvailableNow = function (schedule) {
        var currentWeekDay = this.getCurrentWeekDay();
        var currentUnixTime = this.getCurrentUnixTime();
        for (var _i = 0, _a = schedule.time_periods; _i < _a.length; _i++) {
            var timePeriod = _a[_i];
            if (currentWeekDay === timePeriod.day_week) {
                if (this.getUnixTimeLocal(timePeriod.open_time) < currentUnixTime && currentUnixTime < this.getUnixTimeLocal(timePeriod.close_time)) {
                    return true;
                }
            }
        }
        return false;
    };
    ScheduleAvailabilityTimeHelper.prototype.getCurrentWeekDay = function () {
        return dayjs_1.default().day() === 0 ? 7 : dayjs_1.default().day();
    };
    ScheduleAvailabilityTimeHelper.prototype.getCurrentUnixTime = function () {
        return dayjs_1.default().local().unix();
    };
    ScheduleAvailabilityTimeHelper.prototype.getUnixTimeLocal = function (time) {
        if (!dayjs_1.default(time, 'HH:mm:ss').isValid()) {
            throw new Error('Time is invalid ' + time);
        }
        return dayjs_1.default.utc(time, 'HH:mm:ss').local().unix();
    };
    return ScheduleAvailabilityTimeHelper;
}());
exports.default = ScheduleAvailabilityTimeHelper;
